<script lang="ts">
	import type { Device } from 'src/types/Device';
	import EmeterPriorityView from 'src/components/Sidepanel/DeviceViews/Emeter/EmeterPriorityView.svelte';
	// import EmeterAdvancedView from 'src/components/Sidepanel/DeviceViews/Emeter/EmeterAdvancedView.svelte';

	export let device: Device;
</script>

<EmeterPriorityView {device} />
<!-- <EmeterAdvancedView {device} /> -->
